import { ESellerEmployeeStatus, IOpenInvitationResponse } from './sellerEmployees'

// Супер-админ приглашает и увольняет администраторов и передаёт свою роль
export enum EAdminEmployeeRole {
  OWNER = 'OWNER',
  ADMIN = 'ADMIN'
}

export const ADMIN_EMPLOYEE_ROLE_LABELS: Record<EAdminEmployeeRole, string> = {
  [EAdminEmployeeRole.OWNER]: 'Супер-админ',
  [EAdminEmployeeRole.ADMIN]: 'Администратор'
}

export interface IAdminEmployee {
  _id: string
  // аккаунт появляется, только когда приглашение примут
  user_id: string | null
  name: string
  surname: string
  email: string
  is_email_verified: boolean
  // телефон хранится в аккаунте: до принятия приглашения его нет
  tel: number | null
  is_phone_verified: boolean
  role: EAdminEmployeeRole
  status: ESellerEmployeeStatus
  joined_at: string | null
  fired_at: string | null
  invitation_expires_at: string | null
  createdAt: string
}

// Строка журнала и чёрного списка — браузер (узнаётся по куке, а не по строке
// браузера) со всеми адресами, с которых он входил. У занесённого в чёрный список
// без входов браузера и дат может не быть
export interface IAdminAccessRow {
  device_id: string | null
  browser: string | null
  user_agent: string | null
  ips: string[]
  first_at: string | null
  last_at: string | null
}

export interface IAdminEmployeeAccess {
  log: IAdminAccessRow[]
  blacklist: IAdminAccessRow[]
}

export interface IAdminEmployeeMe {
  role: EAdminEmployeeRole
  employee: IAdminEmployee | null
}

export interface IInviteAdminEmployeeRequest {
  email: string
}

export interface IUpdateAdminEmployeeRequest {
  name?: string
  surname?: string
}

export type IOpenAdminInvitationResponse = Omit<
  IOpenInvitationResponse,
  'shop_name'
>
